<template>
  <button type="button" class="btn btn-info me-2 mb-2" @click="addWaitingList"
          title="Adicionar paciente na lista de espera.">
    <i class="bi bi-clock-history"></i>
  </button>
</template>

<script>
import { patientIdentity } from "../../helpers/patientIdentity";
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Modal from "@/helpers/modal";

export default {
  name: "BtnAddWaitingListSchedule",
  props: ['scheduleEdit'],
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async addWaitingList() {
      Modal.toggle('#modal_patient_schedules');

      const result = await Swal.fire({
        title: 'Lista de espera',
        input: 'textarea',
        inputLabel: 'Observação',
        allowEscapeKey: true,
        showCloseButton: true,
        allowOutsideClick: false,
        confirmButtonColor: 'rgba(120,15,90,0.8)',
        confirmButtonText: "Cadastrar",
        inputPlaceholder: 'Ex. Paciente precisa com urgência.',
      });

      if (result.isDismissed) {
        return;
      }

      let form = {
        wl_name: this.scheduleEdit.patient_name,
        ...patientIdentity(this.scheduleEdit),
        wl_cpf: this.scheduleEdit.patient_cpf,
        wl_phone: this.scheduleEdit.sched_patient_phone ?? this.scheduleEdit.patient_phone ?? this.scheduleEdit.user_phone,
        id_patient: this.scheduleEdit.id_patient,
        id_user: this.userAuth.id_user,
        id_insurance: this.scheduleEdit.id_insurance,
        id_paymeth: this.scheduleEdit.id_paymeth,
        id_prof: this.scheduleEdit.id_prof,
        id_spec: this.scheduleEdit.id_spec,
        id_place: this.scheduleEdit.id_place,
        wl_dt_birth: this.scheduleEdit.patient_birthdate,
        wl_obs: result.value,
      }

      http.post(`/places/${this.scheduleEdit.id_place}/waiting-lists`, form).then(() => {
        Alert.toastSuccess("Paciente adicionado com sucesso.");
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
      });

    }
  }
}
</script>

<style scoped>

</style>